import React, { useEffect } from 'react';
import { App as AntdApp, message as staticMessage } from 'antd';

/** App.useApp() 注入后的 message 实例；注入前回退静态 API */
let messageApi = null;

export function bindAntdMessageApi(api) {
  messageApi = api || null;
}

function getMessageApi() {
  return messageApi || staticMessage;
}

/**
 * 与 antd 静态 message 同形 API，优先使用 App 上下文实例，消除
 * “Static function can not consume context like dynamic theme” 警告。
 */
export const message = {
  success: (content, duration, onClose) => getMessageApi().success(content, duration, onClose),
  error: (content, duration, onClose) => getMessageApi().error(content, duration, onClose),
  info: (content, duration, onClose) => getMessageApi().info(content, duration, onClose),
  warning: (content, duration, onClose) => getMessageApi().warning(content, duration, onClose),
  loading: (content, duration, onClose) => getMessageApi().loading(content, duration, onClose),
  open: (config) => getMessageApi().open(config),
  destroy: (...args) => getMessageApi().destroy?.(...args),
  // config 仅静态 API 支持；同步写到静态层，保证 App 挂载前的 top/maxCount 生效
  config: (...args) => staticMessage.config?.(...args)
};

function AntdMessageBinder({ children }) {
  const { message: ctxMessage } = AntdApp.useApp();
  useEffect(() => {
    bindAntdMessageApi(ctxMessage);
    return () => bindAntdMessageApi(null);
  }, [ctxMessage]);
  return children;
}

/** 包在 ConfigProvider 内：提供可感知主题的 message / modal / notification */
export function AntdAppProvider({ children }) {
  return (
    <AntdApp>
      <AntdMessageBinder>{children}</AntdMessageBinder>
    </AntdApp>
  );
}
